import React, {useContext} from "react";
import Title from "../../ui/title/Title";
import List from "../../ui/list-item/List";
import Wifi1 from './assets/wifi-image-1.png'
import Wifi2 from './assets/wifi-image-2.png'
import Wifi3 from './assets/wifi-image-3.png'
import Wifi4 from './assets/wifi-image-4.png'
import Button from "../../ui/button/Button";
import Form from "../../ui/form/Form";
import './Wifi.css';
import { FormContext } from "../../app/App";

const cardsData = [
    {class: 'image-item', wraper: 'card-wraper-big', img: Wifi1, imageClass: 'list-image-big', title: 'В ресторане', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper-big', img: Wifi2, imageClass: 'list-image-big', title: 'В офисе', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper-big', img: Wifi3, imageClass: 'list-image-big', title: 'На производстве', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper-big', img: Wifi4, imageClass: 'list-image-big', title: 'На складе', titleClass: 'card-title'},
]

export default function Wifi() {
    const { os } = useContext(FormContext);
    return (
        <section id="wifi"  className="main-wifi">
            <p className={`background-line-wifi ${os == 'android' ? 'android-wifi' : ''}`}>Бесшовный WI-FI интернет</p>
            <div className="container">
                <Title props={ {type: 'section-title-big', title: 'Бесшовный WI-FI интернет'} } />
                <p className="wifi-description">Единая WI-FI зона на любых пространствах</p>
                <ul className="wifi-list">
                    {cardsData.map(card => {
                        return <List props={ card } />
                    })}
                </ul>
                <Button props={ {type: 'section-button', name: 'Оставить заявку', dataName: 'WI-FI'} }><Form /></Button>
            </div>
        </section>
    )
}